const sortArray = (array, sortBy = 'text', order = 'asc') => {
  if (!Array.isArray(array)) {
    throw new TypeError('First argument must be an array');
  }
  if (typeof sortBy !== 'string') {
    throw new TypeError('sortBy must be a string');
  }
  if (order !== 'asc' && order !== 'desc') {
    throw new Error("order must be either 'asc' or 'desc'");
  }
  return array.sort((a, b) => {
    const aValue = a[sortBy];
    const bValue = b[sortBy];

    // Using == null instead of === null allows to check for both null and undefined values at once.
    if (aValue == null && bValue == null) return 0;
    if (aValue == null) return 1; // always move null/undefined to the end
    if (bValue == null) return -1; // always move null/undefined to the end

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return order === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }
    return order === 'asc' ? aValue - bValue : bValue - aValue;
  });
};

export default sortArray;
